import { RequestConstants } from "../../../../core/request/RequestConstants";
import { WebRequest } from "../../../../core/request/WebRequest";
import { SetTriggerResponseData } from "../response/data/SetTriggerResponseData";
/**
 * SetTriggerRequest.ts
 */
export class SetTriggerRequest extends WebRequest {
    constructor(params) {
        super(SetTriggerRequest.URL, params);
    }
    getMethod() {
        return RequestConstants.POST;
    }
    getDataClass() {
        return SetTriggerResponseData;
    }
}
SetTriggerRequest.URL = "/responsible-gaming/api/setTrigger";
//# sourceMappingURL=SetTriggerRequest.js.map